/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_AInputs */

const en_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program A`)
};

const fr_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme A`)
};

const de_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm A`)
};

const it_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma A`)
};

const ru_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа А`)
};

const es_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa A`)
};

const zh_cn2_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序 A`)
};

const ja_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムA`)
};

const hi_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम ए`)
};

const pt_pt2_subtitle_export_program_a = /** @type {(inputs: Subtitle_Export_Program_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa A`)
};

/**
* | output |
* | --- |
* | "Program A" |
*
* @param {Subtitle_Export_Program_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_a = /** @type {((inputs?: Subtitle_Export_Program_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_a(inputs)
	if (locale === "de") return de_subtitle_export_program_a(inputs)
	if (locale === "it") return it_subtitle_export_program_a(inputs)
	if (locale === "ru") return ru_subtitle_export_program_a(inputs)
	if (locale === "es") return es_subtitle_export_program_a(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_a(inputs)
	if (locale === "ja") return ja_subtitle_export_program_a(inputs)
	if (locale === "hi") return hi_subtitle_export_program_a(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_a(inputs)
	return en_subtitle_export_program_a(inputs)
});